export class Responsavel {
  id_agendamento: number;
  id_incidente: number;
  dhop1: Date;
  dhop2: Date;
  local: string;
  nomeEnt: string;
  emailEnt: string;
  dataHoraEscolhida: Date;
  token: string;
  responsaveis_incid: string;
}



// WEBPACK FOOTER //
// ./src/app/agendamento/responsavel.ts